"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TreeComponent = void 0;
const gotti_1 = require("gotti");
const Constants_1 = require("../../../Shared/Constants");
class TreeComponent extends gotti_1.Component {
    constructor(treeType) {
        super(Constants_1.SYSTEMS.TREE);
        this.treeType = treeType;
    }
}
exports.TreeComponent = TreeComponent;
//# sourceMappingURL=module.js.map